<template>
  <div>
    <div
      v-for="(option, index) in options"
      :key="`${option.value}-${index}`"
    >
      <div
        class="tw:my-2 tw:cursor-pointer tw:rounded-xs tw:p-3"
        :class="{ 'tw:bg-denim-100': option.value === selectedOption }"
        @click="updateOption(option.value)"
      >
        <BaseIcon :icon="option.icon" />

        <span :class="{ 'tw:font-bold': option.value === selectedOption }">
          {{ option.label }}
        </span>

        <div class="tw:float-right tw:pb-2">
          <div
            class="tw:relative tw:top-[-2px] tw:flex tw:h-6 tw:w-6 tw:items-center tw:justify-center tw:rounded-full tw:bg-denim-200"
          >
            {{ props[option.value] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
type Option = {
  icon: string;
  label: string;
  value: SocialConnectionsType;
};

export type SocialConnectionsType = "accounts" | "hashtags";

type SocialConnectionOptionProps = {
  [key in SocialConnectionsType]?: number;
};
</script>

<script setup lang="ts">
import { ref } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseIcon } from "shared/components/base";

const props = withDefaults(defineProps<SocialConnectionOptionProps>(), {
  accounts: 0,
  hashtags: 0,
});

const selectedOption = defineModel<SocialConnectionsType>("modelValue", {
  default: "accounts",
});

const options = ref<Option[]>([
  {
    icon: "user",
    label: getLocaleText("manage_social_connections.accounts"),
    value: "accounts",
  },
  {
    icon: "hashtag",
    label: getLocaleText("manage_social_connections.hashtags"),
    value: "hashtags",
  },
]);

function updateOption(option: SocialConnectionsType) {
  selectedOption.value = option;
}

defineExpose({
  selectedOption,
});
</script>
